import { createFileRoute } from "@tanstack/react-router";

import { redirectToSignUp } from "@/lib/auth-redirect";

/** A sign-up spelling this app never had. See `redirectToSignUp`. */
export const Route = createFileRoute("/(public)/signup")({
  beforeLoad: redirectToSignUp,
});
